// ============================================================
// Indexable routes: the single list read by scripts/prerender.js
// (via window.__SITE_ROUTES__) to prerender every page and to write
// build/sitemap.xml. A page missing here 404s on direct load.
//
// `sources` are the files whose last git commit date becomes the
// sitemap <lastmod>; `lastmod` (YYYY-MM-DD) overrides it.
// ============================================================

import { paths } from './models/paths';
import { blogPosts, blogImage } from './models/blogPosts';

const domesticSections = [
  'src/components/DomesticHero.js',
  'src/components/DomesticIntro.js',
  'src/components/WhyPureNest.js',
  'src/components/DomesticServices.js',
  'src/components/DomesticAddOns.js',
  'src/components/HouseServiceLinks.js',
  'src/components/DomesticHowItWorks.js',
  'src/components/DomesticFAQ.js',
  'src/components/DomesticFinalCTA.js',
];

const commercialSections = [
  'src/components/Hero.js',
  'src/components/Services.js',
  'src/components/TenderSection.js',
  'src/components/Requirements.js',
  'src/components/CommercialSEOContent.js',
];

const pageShell = ['src/templates/PageShell.js'];
const servicePage = (file) => [file, 'src/templates/ServicePageTemplate.js', ...pageShell];

export const staticRoutes = [
  { path: paths.home, changefreq: 'weekly', priority: 1.0, sources: ['src/pages/ServiceSelectorPage.js'] },
  { path: paths.houseHub, changefreq: 'weekly', priority: 0.9, sources: ['src/pages/DomesticCleaningPage.js', ...domesticSections] },
  { path: paths.prices, changefreq: 'monthly', priority: 0.9, sources: ['src/pages/DomesticServicesPage.js', 'src/components/PriceGuideLinks.js', 'src/models/dataModel.js'] },
  { path: paths.endOfTenancy, changefreq: 'monthly', priority: 0.9, sources: servicePage('src/pages/EndOfTenancyCleaningPage.js') },
  { path: paths.deep, changefreq: 'monthly', priority: 0.9, sources: servicePage('src/pages/DeepCleaningPage.js') },
  { path: paths.regular, changefreq: 'monthly', priority: 0.9, sources: servicePage('src/pages/RegularHouseCleaningPage.js') },
  { path: paths.ovenCarpet, changefreq: 'monthly', priority: 0.8, sources: servicePage('src/pages/OvenCarpetCleaningPage.js') },
  { path: paths.commercial, changefreq: 'weekly', priority: 0.9, sources: ['src/pages/CommercialPage.js', ...commercialSections] },
  { path: paths.office, changefreq: 'monthly', priority: 0.8, sources: servicePage('src/pages/OfficeCleaningPage.js') },
  { path: paths.school, changefreq: 'monthly', priority: 0.8, sources: servicePage('src/pages/SchoolCleaningPage.js') },
  { path: paths.projects, changefreq: 'monthly', priority: 0.7, sources: ['src/pages/TenderPage.js', 'src/models/dataModel.js'] },
  { path: paths.about, changefreq: 'monthly', priority: 0.7, sources: ['src/pages/AboutPage.js'] },
  { path: paths.contact, changefreq: 'monthly', priority: 0.7, sources: ['src/pages/ContactPage.js', 'src/components/ContactForm.js'] },
  { path: paths.blog, changefreq: 'weekly', priority: 0.6, sources: ['src/pages/BlogIndexPage.js', 'src/models/blogPosts.js'] },
];

// Suburb/area pages (S13) are on hold, so none are listed here yet.
// Blog <lastmod> is the post's own edit date, so it matches the "Last updated"
// date shown on the page (fix list F04). Bump `updated` in blogPosts.js on edits.
// `ogImage` tells scripts/prerender.js to draw the post's share image.
export const blogRoutes = blogPosts.map((post) => ({
  path: post.path,
  changefreq: 'monthly',
  priority: 0.6,
  lastmod: post.updated || post.published,
  ogImage: { file: blogImage(post.path), title: post.label },
}));

const siteRoutes = [...staticRoutes, ...blogRoutes];

export default siteRoutes;
